import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const GridArea = {
  coverart: "coverart",
  details: "details",
  description: "description",
  organizer: "organizer",
};

export const useStyles = makeStyles((theme) => {
  const { coverart, details, organizer, description } = GridArea;

  return {
    root: {
      margin: "20px auto 0",
      position: "relative",
      [theme.breakpoints.down("md")]: {
        margin: 0,
        backgroundColor: theme.palette.common.white,
      },
    },
    container: {
      display: "grid",
      gridTemplate: `"${coverart}    ${details}"
                      "${organizer}   ${details}"
                      "${description} ${details}"`,
      gridTemplateRows: "minmax(min-content, max-content)  1fr",
      gridTemplateColumns: "minmax(min-content, 780px) 1fr",
      gridGap: theme.spacing(3),

      [theme.breakpoints.down("md")]: {
        gridTemplate: `"${coverart}" "${details}" "${organizer}" "${description}"`,
        gridGap: theme.spacing(0),
      },
    },
    organizeCard: {
      [theme.breakpoints.down("lg")]: {
        paddingTop: 0,
      },
    },
    organizeInner: {
      display: "flex",
      [theme.breakpoints.down("lg")]: {
        flexDirection: "column",
        alignItems: "flex-start",
        marginTop: theme.spacing(2),
      },
    },
    shareContainer: {
      [theme.breakpoints.down("lg")]: {
        paddingTop: theme.spacing(2),
      },
    },
    shareContainerNoSharer: {
      justifyContent: "end",
    },
    actionButtons: {
      lineHeight: "1.5rem",
      whiteSpace: "nowrap",
      marginRight: theme.spacing(2),
    },
    actionButtonIcons: {
      marginRight: ".5rem",
    },
    logoImage: {
      width: "40px",
      height: "40px",
    },
    actionButtonsWrapper: {
      textTransform: "none",
    },
  };
});
